import { render, staticRenderFns } from "./MostrarImagen.vue?vue&type=template&id=e797de6e&scoped=true&"
import script from "./MostrarImagen.vue?vue&type=script&lang=js&"
export * from "./MostrarImagen.vue?vue&type=script&lang=js&"
import style0 from "./MostrarImagen.vue?vue&type=style&index=0&id=e797de6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e797de6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VProgressCircular,VRow})
